import styled from "@emotion/styled";

const Option = styled.option`
  color: ${(props) => props.theme.form.inputTextColor};
`;

export default Option;
